module.exports = __webpack_public_path__ + "static/img/ddz-02.1e5b957e.jpg";